import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=34554330"
import script from "./Newsletter.vue?vue&type=script&lang=ts"
export * from "./Newsletter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports